const isDev = process.env.NODE_ENV !== 'production';

export const logError = (...args) => {
  if (isDev) console.error(...args);
};
